import React, { useEffect } from 'react'
import classnames from 'classnames'
import Icon from '@/components/Icon'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from './breadcrumbs'
import { HelpButton, HelpBox } from '@/components/help'
import ErrorBoundary from '@/components/ErrorBoundary'
import { useLocalization } from '@/hooks/localization'
import { getStore } from '@/store'
import { dialogTypes } from '@/dialogs'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import context from '@/context'

function getRoutes () {
  if (context.isInternalApp()) {
    return require('@/internal-app/route-config').getInternalRoutes()
  } else {
    return require('@/report-app/route-config').getReportRoutes()
  }
}

export function Main ({ className, children, path }) {
  const { localize } = useLocalization()

  useEffect(() => {
    const interceptClickEvent = (e) => {
      const href = e.target.href
      if (href && !href.match(/javascript:.*/i)) {
        const isPath = (href.match(/^(?:\w+:\/\/)*(?:\w+\.)+\w+\/.*/i) && !href.includes(document.location.hostname))
          ? false : (getRoutes()).some(route => {
            if (route.path && route.path !== '/') {
              return (((href[0] === '/' ? '' : '/') + (href)).match(new RegExp(route.path)))
            }
          })
        if (href.includes(document.location.hostname) === false && href[0] !== '#' && isPath === false) {
          e.preventDefault()
          getStore().dispatch(dialogActions.openDialog({
            dialogType: dialogTypes.confirm,
            title: 'Common:Confirmation',
            content: localize('Common:ConfirmRedirection', [document.location.hostname, href], false),
            onAction: () => {
              window.location.href = href
            }
          }))
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener('click', interceptClickEvent)
    } else if (document.attachEvent) {
      document.attachEvent('onclick', interceptClickEvent)
    }

    return () => {
      document.removeEventListener('click', interceptClickEvent)
    }
  }, [localize])

  return (<div className={classnames('main', className)}>
    <Breadcrumbs path={path} />
    {children}
  </div>)
}

// Main top
export function MainTop (props) {
  return (<div className='main__top'>
    <div className={classnames('main__top-inner', props.className)}>{props.children}
      <HelpButton />
    </div>
  </div>)
}

export function MainTopTitle (props) {
  return (
    <div className='main-top__title'>
      {!!props.backUrl &&
        <Link className='main-top__back' to={props.backUrl}><Icon name='reply' /></Link>
      }
      <div className='main-top__title-text'>{props.children}</div>
    </div>
  )
}

export function MainTopLeft (props) {
  return <div className='main-top__left'>{props.children}</div>
}

export function MainTopRight (props) {
  return <div className='main-top__right'>{props.children}</div>
}

export function MainBody (props) {
  let isTransparent = props.transparent || props.clear
  let classNames = isTransparent ? classnames('main__body main-body--transparent', props.className) : classnames('main__body', props.className)
  return (
    <React.Fragment>
      <ErrorBoundary>
        <HelpBox />
      </ErrorBoundary>
      <ErrorBoundary>
        <div className={classNames}>{props.children}</div>
      </ErrorBoundary>
    </React.Fragment>
  )
}

export function Cms (props) {
  return <div className={classnames('cms', props.className)}>{props.children}</div>
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.Main.js